import classNames from 'classnames';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import { ButtonPrimary, FileUpload, FileUploadInvalidPayload } from '../../../components';
import styles from './TabelaPrecosUploadModal.module.scss';

type TabelaPrecosUploadModalProps = ModalProps & {
  file: File | null;
  errorMessage?: string | null;
  onFileChange: (file: File | null) => void;
  onInvalidFile: (payload: FileUploadInvalidPayload) => void;
  onDownloadTemplate: () => void;
  onSubmit: () => void;
  onHide: () => void;
};

export const TabelaPrecosUploadModal = ({
  className,
  file,
  errorMessage,
  onFileChange,
  onInvalidFile,
  onDownloadTemplate,
  onSubmit,
  onHide,
  show,
  ...props
}: TabelaPrecosUploadModalProps) => (
  <Modal className={classNames('info-modal', styles.modal, className)} onHide={onHide} show={show} {...props}>
    <form onSubmit={event => event.preventDefault()}>
      <Modal.Header>
        <div className={styles.header}>
          <Modal.Title className={styles.title}>Novo envio de tabela de preços</Modal.Title>
          <p>Processamos seu arquivo e atualizamos os preços dos produtos por loja.</p>
        </div>
      </Modal.Header>

      <Modal.Body className={styles.body}>
        <FileUpload
          value={file}
          onChange={onFileChange}
          onInvalidFile={onInvalidFile}
          errorMessage={errorMessage}
          onTemplateClick={onDownloadTemplate}
          description={
            <p>
              Aceitamos arquivos .xlsx, .xls e .csv. <br /> Arraste e solte aqui ou clique para selecionar.
            </p>
          }
          inputProps={{ id: 'price-table-file' }}
        />
      </Modal.Body>

      <Modal.Footer>
        <ButtonPrimary skin="blue" theme="ghost" type="button" onClick={onHide}>
          CANCELAR
        </ButtonPrimary>
        <ButtonPrimary skin="blue" theme="filled" type="submit" disabled={!file || Boolean(errorMessage)} onClick={onSubmit}>
          ENVIAR TABELA
        </ButtonPrimary>
      </Modal.Footer>
    </form>
  </Modal>
);
